<template>
  <div class="kanban-container p-3">
    <div class="d-flex flex-nowrap overflow-auto h-100 kanban-board">
      <div
        v-for="column in localColumns"
        :key="column.id"
        class="kanban-col d-flex flex-column"
      >
        <div class="kanban-col-header">
          <span class="font-weight-bold text-truncate">{{ column.title }}</span>
          <b-badge class="kanban-badge-custom" :class="column.class">
            {{ column.items.length }}
          </b-badge>
        </div>

        <div class="kanban-col-body">
          <draggable
            v-model="column.items"
            :group="groupName"
            @change="(evt) => onItemMoved(evt, column.id)"
            animation="200"
            ghost-class="ghost-card"
            class="kanban-draggable-area"
          >
            <slot
              v-for="item in column.items"
              name="card"
              :item="item"
            />
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'Kanban',
  components: { draggable },
  props: {
    items: { type: Array, default: () => [] },
    columns: { type: Array, required: true },
    groupName: { type: String, required: true },
    columnValue: { type: String, required: true }
  },
  data() {
    return {
      localColumns: []
    };
  },
  methods: {
    throwItemsToColumns(items) {
      const newColumns = this.columns.map(col => ({ ...col, items: [] }));

      if (items && items.length) {
        items.forEach(item => {
          const targetCol = newColumns.find(col => col.id === item[this.columnValue]);
          if (targetCol) {
            targetCol.items.push(item);
          }
        });
      }

      this.localColumns = newColumns;
    },
    onItemMoved(evt, newStatusId) {
      if (evt.added) {
        const item = evt.added.element;
        this.$emit('status-updated', {
          item: item,
          newStatus: newStatusId,
          oldStatus: item[this.columnValue]
        });
      }
    }
  },
  watch: {
    items: {
      handler(newItems) {
        this.throwItemsToColumns(newItems);
      }, deep: true, immediate: true
    },
    columns: {
      handler(newCols) {
        const currentItemsMap = this.localColumns.reduce((acc, col) => {
          acc[col.id] = col.items;
          return acc;
        }, {});

        this.localColumns = newCols.map(col => {

          if (currentItemsMap[col.id]) {
            return {...col, items: currentItemsMap[col.id]};
          }

          const restoredItems = this.items.filter(
            item => String(item[this.columnValue]) === String(col.id)
          );

          return {...col, items: restoredItems};
        });
      }, deep: true
    }
  },
};
</script>

<style scoped>
.kanban-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #FFFFFF;
}

.kanban-board {
  gap: 16px;
  padding-bottom: 8px;
  flex: 1 1 auto;
}

.kanban-col {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 8px;
  gap: 8px;

  min-width: 240px;
  width: 240px;
  max-height: 100%;

  background: #F5F6F7;
  border-radius: 12px;
  flex: none;
}

.kanban-col-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.kanban-badge-custom {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 22px;
  height: 22px;
  padding: 1px 7px;

  border-radius: 4px;
  vertical-align: middle;
}

.kanban-col-body {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 -8px;
  padding: 0 8px;
  scrollbar-width: thin;
}

.kanban-draggable-area {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 100%;
  padding-bottom: 8px;
}

.ghost-card {
  opacity: 0.5;
  background: #c8ebfb;
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/Kanban.vue